import React from 'react';
import { Col, Divider, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Description } from './styles';

export const Header: React.FC = () => (
	<Row justify="end">
		<Col xs={14} style={{ paddingLeft: '1rem' }}>
			<Description>
				<span>{I18n.get('Details')}</span>
			</Description>
		</Col>
		<Divider style={{ margin: 0, height: 'auto' }} type="vertical" />
	</Row>
);
